import request from '@/utilsCloud/request'
import port from './port'
// 登录方法-----其他
export function login(username, password, entpId, userType) {
  return request({
    url: '/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: {
      username,
      password,
      entpId
    }
  })
}



// 登录方法---职业技能工
export function jzLogin(username, password, entpId, userType) {
  return request({
    url: '/auth/jzLogin',
    headers: {
      isToken: false
    },
    method: 'post',
    data: {
      username,
      password,
      entpId
    }
  })
}



// 登录
export function enterpriseEmployeeLogin(data) {
  return request({
    url: port.biz + '/employee/enterpriseEmployeeLogin',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}


// 注册方法
export function register(query) {
  return request({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    params: query
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}


export function empAdmissionTicket(data) {
  return request({
    url: port.exam + '/bizExerciseEmployee/empAdmissionTicket',
    headers: {
      isToken: false,
      isEntpId: false
    },
    method: 'get',
    params: data
  })
}

// 小程序二维码
export function getUnlimitedQRCode(data={}) {
  return request({
    url: port.biz +'/employee/getUnlimitedQRCode',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
// 获取小程序二维码状态
export function getWxacodeStatus(data={}) {
  return request({
    url: port.biz +'/employee/getWxacodeStatus',
    headers: {
      isToken: false,
    },
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/login.js